import React, { useEffect, useCallback } from "react"
import _ from "lodash"
import { withApi } from "@tencent/react-aio"
import { connect } from "react-redux"
import * as ActionTypes from "@/stores/sale/actions"
import { Select } from "@tencent/spaui"
import { SelectTree } from "@tencent/spaui-business"

interface weChatLabelItem {
  groupId: string;
  groupName: string;
  tag: {
    id: string;
    name: string;
  }[];
}

interface WeChatLabelSelectProps {
  value: number | null | string[];
  multiple: boolean;
  onChange: () => void;
  weChatLabelList: {
    data: weChatLabelItem[];
  };
  webApi: {
    getCorpTagConfig: () => any;
  }
}

const handleList = (list: {data: weChatLabelItem[]}) => {
  if (!_.isArray(list.data)) return [];
  return _.map((list.data), (d: weChatLabelItem) => {
    return {
      value: "",
      desc: d.groupName,
      options: d?.tag.map(v => {
        return {
          parent_id: d.groupId,
          desc: v.name,
          value: v.id,
        }
      }),
      parent_id: "",
    }
  })
}

const WeChatLabelSelect: React.FC<WeChatLabelSelectProps> = (props) => {

  useEffect(() => {
    getWeChatLabelData()
  }, [])

  const getWeChatLabelData = () => {
    const { webApi, weChatLabelList } = props;
    if (!_.isArray(weChatLabelList?.data)) {
      webApi
        .getCorpTagConfig()
        .dispatchJson(ActionTypes.FETCH_WECHAT_LABEL_LIST)
    }
  }

  const { value, onChange, weChatLabelList, multiple = false } = props

  return (
    <SelectTree
      value={value}
      data={handleList(weChatLabelList)}
      onChange={onChange}
      multiple={multiple}
      // ValueAreaComponent={ValueAreaComponent}
      clear
      dropStyle={{ width: 400 }}
    />
  )
}

function mapStateToProps(state: any) {
  return {
    weChatLabelList: state.weChatLabelList || {},
  }
}

export default withApi(connect(mapStateToProps)(WeChatLabelSelect))
